import { render, staticRenderFns } from "./previewSCCL.vue?vue&type=template&id=1ece5c5e&scoped=true&lang=html&"
import script from "./previewSCCL.vue?vue&type=script&lang=js&"
export * from "./previewSCCL.vue?vue&type=script&lang=js&"
import style0 from "./previewSCCL.vue?vue&type=style&index=0&id=1ece5c5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ece5c5e",
  null
  
)

export default component.exports